import { SelectField } from "$components/rhf-fields";
import { SUPPLIER_OPTIONS } from "$components/supplier-labels";
import { useIntl } from "react-intl";

interface SupplierSelectInputProps {
  name: string;
  disabled?: boolean;
}

export const SupplierSelectInput = ({
  name,
  disabled,
}: SupplierSelectInputProps) => {
  const { formatMessage } = useIntl();

  return (
    <SelectField
      name={name}
      options={SUPPLIER_OPTIONS}
      disabled={disabled}
      required
      fullWidth
      hideHelper
      label={formatMessage({
        id: "invoicing.invoice.lineItem.header.supplier",
        defaultMessage: "Supplier",
      })}
    />
  );
};
